import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#3f51b5",
        secondary: "#b0bec5",
        accent: "#8c9eff",
        error: "#b71c1c",
        lightBlue: "#6a6a6a",
        orange: "#000000",
        darkGrey: "#6a6a6a",
        faqQuestionText: "#6a6a6a"
      }
    }
  }
});
